import axios from "axios";
// axios.defaults.baseURL = "http://172.31.4.34:3000/web-server";
axios.defaults.baseURL = "http://www.peiyinge.com/web-server";
axios.defaults.headers.post["Content-Type"] = "application/json";
var myAES = "";
const CryptoJS = require("crypto-js");

const baseParams = {
  channel: "10000001"
};
function getAES() {
  return axios.post("/exchange", {}, { responseType: "text" }).then(resp => {
    localStorage.DATAAUDIT = resp.data;
    return Promise.resolve(resp.data);
  });
}
var setAES = function() {
  var c = CryptoJS.enc.Utf8.stringify(
    CryptoJS.enc.Base64.parse(localStorage.DATAAUDIT)
  );
  var b = c.substring(16, c.length - 16);
  for (var a = 0; a < b.length; a += 2) {
    myAES += b.charAt(a);
  }
};
getAES();
export function get(url, params) {
  return axios.get(url, {
    params: {
      ...params
    }
  });
}
export function webserver(url, data = {}, isJson = true) {
  return new Promise((resolve, reject) => {
    new Promise((resolve,reject)=>{
      if (!myAES && localStorage.DATAAUDIT) {
        setAES();
        resolve();
      } else if(!myAES){
        getAES().then(()=>{
          setAES();
          resolve();
        }).catch(e=>{
          reject(e)
        })
      } else {
        resolve();
      }
    }).then(()=>{
      axios
      .post(url, data, {
        timeout: 15000,
        responseType: isJson ? "json" : "text",
        transformRequest: [
          function(data, headers) {
            // Do whatever you want to transform the data
            data = { ...baseParams, ...data };
            console.info(`[${url}:req params]::`, data);
            data = data ? JSON.stringify(data) : "";
            var encryptedData = CryptoJS.AES.encrypt(
              data,
              CryptoJS.enc.Utf8.parse(myAES),
              {
                v: "",
                mode: CryptoJS.mode.ECB
              }
            ).toString();
            return JSON.stringify({
              req: encryptedData
            });
          }
        ], // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
        transformResponse: [
          function(resp) {
            // 对 data 进行任意转换处理
            console.log("response", resp);
            let respData = resp;
            if (resp.status === 0) {
              var j = CryptoJS.AES.decrypt(
                resp.body,
                CryptoJS.enc.Utf8.parse(myAES),
                {
                  iv: "",
                  mode: CryptoJS.mode.ECB
                }
              );
              j = JSON.parse(CryptoJS.enc.Utf8.stringify(j));
              respData.body = j;
            }
            return respData;
          }
        ]
      })
      .then(resp => {
        if (resp.data && resp.data.status === 0) {
          resolve(resp.data.body);
        } else {
          reject(resp.data);
        }
      })
      .catch(e => {
        reject(e);
      });
    })
  });
}
